<template>
	<div>
		<div class="w-100 text-center py-3 border-bottom">
			<p class="body-2 mb-1">{{$t('payment-result.payment-time')}}</p>
			<p class="heading-4-1 mb-0" v-if="timeout">00:00:00</p>
			<p v-else class="heading-4-1 mb-0">
				<template v-if="countdown.hours() < 10">
					0{{countdown.hours()}}:
				</template>
				<template v-else>
					{{countdown.hours()}}:
				</template>
				<template v-if="countdown.minutes() < 10">
					0{{countdown.minutes()}}:
				</template>
				<template v-else>
					{{countdown.minutes()}}:
				</template>
				<template v-if="countdown.seconds() < 10">
					0{{countdown.seconds()}}
				</template>
				<template v-else>
					{{countdown.seconds()}}
				</template>
			</p>
			<!-- <p class="body-3-3-1 mb-0">Sebelum Jumat, 24 Juli 2020, 17:25</p> -->
		</div>
		<div class="w-100 py-3 text-center border-bottom">
			<p class="body-3 mb-1">{{$t('payment-result.payment-paid')}}</p>
			<p class="body-2-4 text-orange mb-1 text-22">{{totalPaymentLabel}}</p>
			<PaymentChargeInfo v-if="chargeInfo" :charge-info="chargeInfo" :base-amount-label="baseTotalLabel" class="mb-1" />
			<p class="body-3 mb-0 text-green cursor-pointer" @click="$copyText(copyAmount, $t('payment-result.total-bill-copy'))">{{$t('payment-result.copy-amount')}}</p>
		</div>
		<div class="w-100 py-3 text-center">
			<div class="container p-3 text-left bg-light rounded-6 box-shadow-bold border mb-3">
				<p class="heading-6-1 mb-2 pb-2 border-bottom w-100 text-center">{{payment.payment_method_name}}</p>
      	<div class="row">
      		<div class="col-12 text-center col-sm-12">
        		<img :src="qris_image" class="w-100 mb-3 mx-auto">
      		</div>
      	</div>
        <p class="body-3-1 mb-2 text-orange border-orange d-table mx-auto px-2 rounded cursor-pointer" @click="$openLink(qris_image,'_blank')">Download QRIS</p>
        <p class="body-3-3-1 mb-0 text-center html-desc" v-if="!(payment.payment_channel_description == null || payment.payment_channel_description == '')" v-html="payment.payment_channel_description"></p>
			</div>
		</div>
	</div>
</template>
<script>
	import {mapGetters} from 'vuex'
	import moment from 'moment';
	import {buildTxChargeInfo} from '@/utils/index.js'
	import PaymentChargeInfo from '@/components/v2/payment/PaymentChargeInfo.vue'

	export default{
		components:{
			PaymentChargeInfo
		},
		props: ['data'],
		data(){
			return{
				countdown: moment(),
	      timeout: false,
        reload: false
			}
		},
		computed:{
			total_payment(){
      	const payments = this.data.payments || {}
      	return Number(payments.total_deposit)+Number(payments.payment_surcharge)
      },
      chargeInfo(){
      	return buildTxChargeInfo(this.data.payments)
      },
      baseTotalLabel(){
      	return this.$formatCurrency(this.total_payment)
      },
      // the QR is issued in the converted amount, so that is what leads and gets copied
      totalPaymentLabel(){
      	return this.chargeInfo ? this.chargeInfo.amountLabel : this.baseTotalLabel
      },
      copyAmount(){
      	return this.chargeInfo ? this.chargeInfo.amount : this.total_payment
      },
      payment(){
      	if(this.data.payment_details){
      		return this.data.payment_details
      	}else{
      		return {}
      	}
      },
      qris_image(){
      	if(this.data.payment_details){
      		if(this.payment.bank_name == 'IPAYMU' || this.payment.bank_name == 'XENDIT'){
      			return `data:image/png;base64,${this.payment.qr_image}` 
      		}else{
      			return null
      		}
      	}else{
      		return null
      	}
      }
		},
		mounted(){
			this.countAutoCancel()
		},
		methods:{
			countAutoCancel(){
				let offset_time = ""
				if(this.payment.bank_name == 'IPAYMU' || this.payment.bank_name == 'XENDIT'){
					offset_time = "+07:00"
				}

				let now = moment().format("YYYY-MM-DD HH:mm:ss")
				let exp = moment(this.payment.expired_date).format("YYYY-MM-DD HH:mm:ss")

				if(offset_time != ''){
					let exp_date = moment(this.payment.expired_date).format("HH:mm:ss")
					let local_tz = moment().format("Z")
					let exp_z = moment(`${exp_date}${offset_time}`,'HH:mm:ssZ').format()
		      exp = moment.parseZone(exp_z).local().format("YYYY-MM-DD HH:mm:ss")
				}
	      this.countdown = moment.duration(moment(exp).diff(moment(now)))

	      let looping = setInterval(() => {
	          this.countdown = this.countdown.subtract(1, 'seconds')
	        if (this.countdown.hours() <= 0 && this.countdown.minutes() <= 0 && this.countdown.seconds() <= 0) {
	          clearInterval(looping)
	          this.timeout = true
	        }
	      },1000)

				if(this.payment.bank_name == 'IPAYMU'){
		      
				}
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/general/QrisForm.vue